import { useTranslation } from 'react-i18next'

import { MoreActionsButton } from '../../MoreActionsButton'
import { TableModalActions } from '../TableModalActions'
import { TableModalButtonConnect } from '../TableModalButtonConnect'
import { TableModalButtonDisconnect } from '../TableModalButtonDisconnect'
import { TableModalButtonDisconnectAll } from '../TableModalButtonDisconnectAll'

import {
  getTableModalConnectionActionsMoreActions,
  isTableModalConnectionActionsSelectionEmpty,
} from './TableModalConnectionActions.utils'

function TableModalConnectionActions({
  ButtonConnect = TableModalButtonConnect,
  ButtonDisconnect = TableModalButtonDisconnect,
  ButtonDisconnectAll = TableModalButtonDisconnectAll,
  More = MoreActionsButton,
  buttonConnectProps,
  buttonDisconnectAllProps,
  buttonDisconnectProps,
  emptySelectionTooltipKey = 'Modal.RequestsDisconnectEmptySelectionTooltipKey',
  isFullScreen,
  isSkeleton,
  selectAllPages,
  selected,
  ...restProps
}) {
  const { t } = useTranslation()

  const isSelectionEmpty = isTableModalConnectionActionsSelectionEmpty({
    selectAllPages,
    selected,
  })

  return (
    <TableModalActions {...restProps} isSkeleton={isSkeleton}>
      {isFullScreen ? (
        <>
          {ButtonConnect ? (
            <ButtonConnect {...buttonConnectProps} isSkeleton={isSkeleton} />
          ) : null}
          {ButtonDisconnectAll ? (
            <ButtonDisconnectAll
              {...buttonDisconnectAllProps}
              isSkeleton={isSkeleton}
            />
          ) : null}
          {ButtonDisconnect ? (
            <ButtonDisconnect
              {...buttonDisconnectProps}
              disabled={isSelectionEmpty}
              isSkeleton={isSkeleton}
              tooltip={isSelectionEmpty ? t(emptySelectionTooltipKey) : null}
            />
          ) : null}
        </>
      ) : (
        <More
          actions={getTableModalConnectionActionsMoreActions({
            ButtonConnect,
            ButtonDisconnect,
            ButtonDisconnectAll,
            buttonConnectProps,
            buttonDisconnectAllProps,
            buttonDisconnectProps,
            isSelectionEmpty,
            t,
          })}
          text={t('Common.More')}
        />
      )}
    </TableModalActions>
  )
}

export default TableModalConnectionActions
